import { appEntry } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="w-full lg:w-5/12 flex justify-center">
            <div className="relative w-64 h-[500px] rounded-[2.5rem] border-[6px] border-foreground-900 bg-foreground-950 overflow-hidden">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-foreground-900 rounded-b-2xl z-10" />
              <div className="h-full flex flex-col pt-10 px-4">
                <div className="flex items-center gap-2 mb-4">
                  <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-xs">琪</span>
                  <span className="text-sm font-semibold text-background-50">琪琪影院</span>
                </div>
                <div className="flex-1 grid grid-cols-2 gap-2">
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="rounded-lg bg-foreground-800/50 aspect-[3/4]" />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-7/12">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
              移动端体验
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              {appEntry.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appEntry.description}
            </p>
            <div className="grid grid-cols-2 gap-3">
              {appEntry.features.map((f) => (
                <div key={f} className="flex items-center gap-2 px-4 py-3 bg-background-50 rounded-xl border border-background-200/70">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-lg" />
                  <span className="text-sm font-medium text-foreground-700">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}